import React, { useState, useEffect } from 'react';
import api from '../utils/api';
import toast from 'react-hot-toast';

export default function Corrections() {
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState({ date:'', requested_check_in:'', requested_check_out:'', reason:'' });
  const [loading, setLoading] = useState(false);
  const set = k => e => setForm(f=>({...f,[k]:e.target.value}));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post('/corrections/request', form);
      toast.success('Correction request submitted');
      setShowForm(false);
      setForm({ date:'', requested_check_in:'', requested_check_out:'', reason:'' });
    } catch (err) {
      toast.error(err.response?.data?.error || 'Request failed');
    } finally { setLoading(false); }
  };

  return (
    <div>
      <div className="flex-between mb-16">
        <h1 className="page-title" style={{marginBottom:0}}>Attendance Correction</h1>
        <button className="btn btn-primary" onClick={() => setShowForm(!showForm)}>
          {showForm ? 'Cancel' : '+ Request Correction'}
        </button>
      </div>

      {showForm && (
        <div className="card">
          <div className="card-title">Request Attendance Correction</div>
          <p className="text-muted mb-16" style={{fontSize:13}}>
            Use this if you forgot to check in or out, or if the time recorded was incorrect.
          </p>
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label className="form-label">Date to Correct</label>
              <input className="form-control" type="date" required value={form.date} onChange={set('date')}/>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label className="form-label">Correct Check-in Time</label>
                <input className="form-control" type="time" value={form.requested_check_in} onChange={set('requested_check_in')}/>
              </div>
              <div className="form-group">
                <label className="form-label">Correct Check-out Time</label>
                <input className="form-control" type="time" value={form.requested_check_out} onChange={set('requested_check_out')}/>
              </div>
            </div>
            <div className="form-group">
              <label className="form-label">Reason <span style={{color:'var(--danger)'}}>*</span></label>
              <textarea className="form-control" rows="3" required
                value={form.reason} onChange={set('reason')}
                placeholder="Explain why the correction is needed"/>
            </div>
            <button className="btn btn-primary" type="submit" disabled={loading}>
              {loading ? 'Submitting...' : 'Submit Correction Request'}
            </button>
          </form>
        </div>
      )}

      {!showForm && (
        <div className="card">
          <div className="empty-state">
            <div className="icon">✏️</div>
            <p>Need to fix a wrong check-in or check-out time?</p>
            <p className="text-sm text-muted mt-16">Click <strong>Request Correction</strong> above and your manager will review it.</p>
          </div>
        </div>
      )}
    </div>
  );
}
